import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { Role } from './models/role.enum';
import { Layout } from './components/layout/layout';
import { roleGuard } from './guards/role.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '401',
    loadComponent: () => import('./components/pages/page401/page401').then(m => m.Page401),
  },
  {
    path: '',
    component: Layout,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/pages/dashboard/dashboard').then(m => m.Dashboard),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'anagrafica',
        loadComponent: () => import('./components/pages/fornitori/anagrafica/anagrafica').then(m => m.Anagrafica),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE] }
      },
      {
        path: 'fornitori',
        loadComponent: () => import('./components/pages/fornitori/fornitori').then(m => m.Fornitori),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'fornitori/create',
        loadComponent: () => import('./components/pages/fornitori/fornitori-create/fornitori-create').then(m => m.FornitoriCreate),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'fornitori/edit/:id',
        loadComponent: () => import('./components/pages/fornitori/fornitori-edit/fornitori-edit').then(m => m.FornitoriEdit),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'fornitori/view/:id',
        loadComponent: () => import('./components/pages/fornitori/fornitori-view/fornitori-view').then(m => m.FornitoriView),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'filiali',
        loadComponent: () => import('./components/pages/filiali/filiali').then(m => m.Filiali),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'filiali/create',
        loadComponent: () => import('./components/pages/filiali/filiali-create/filiali-create').then(m => m.FilialiCreate),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'filiali/edit/:id',
        loadComponent: () => import('./components/pages/filiali/filiali-edit/filiali-edit').then(m => m.FilialiEdit),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'utenti',
        loadComponent: () => import('./components/pages/utenti/utenti').then(m => m.Utenti),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'utenti/create',
        loadComponent: () => import('./components/pages/utenti/user-create/user-create.component').then(m => m.UserCreateComponent),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'utenti/edit/:id',
        loadComponent: () => import('./components/pages/utenti/user-update/user-update.component').then(m => m.UserUpdateComponent),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'contratti',
        loadComponent: () => import('./components/pages/contratti/contratti').then(m => m.Contratti),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.FORNITORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'contratti/create',
        loadComponent: () => import('./components/pages/contratti/contratti-create/contratti-create').then(m => m.ContrattiCreate),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'contratti/edit/:id',
        loadComponent: () => import('./components/pages/contratti/contratti-edit/contratti-edit').then(m => m.ContrattiEdit),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'contratti/view/:id',
        loadComponent: () => import('./components/pages/contratti/contratti-view/contratti-view').then(m => m.ContrattiView),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.FORNITORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'dipendenti',
        loadComponent: () => import('./components/pages/dipendenti/dipendenti').then(m => m.Dipendenti),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'dipendenti/create',
        loadComponent: () => import('./components/pages/dipendenti/dipendenti-create/dipendenti-create').then(m => m.DipendentiCreate),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'dipendenti/edit/:id',
        loadComponent: () => import('./components/pages/dipendenti/dipendenti-edit/dipendenti-edit').then(m => m.DipendentiEdit),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'dipendenti/view/:id',
        loadComponent: () => import('./components/pages/dipendenti/dipendenti-view/dipendenti-view').then(m => m.DipendentiView),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'assets',
        loadComponent: () => import('./components/pages/assets/assets').then(m => m.Assets),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'assets/create',
        loadComponent: () => import('./components/pages/assets/assets-create/assets-create').then(m => m.AssetsCreate),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'assets/edit/:id',
        loadComponent: () => import('./components/pages/assets/assets-edit/assets-edit').then(m => m.AssetsEdit),
        canActivate: [roleGuard],
        data: { roles: [Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'documenti',
        loadComponent: () => import('./components/pages/documenti/documenti').then(m => m.Documenti),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.OPERATORE, Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'templates',
        loadComponent: () => import('./components/pages/templates/templates').then(m => m.Templates),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'templates/create',
        loadComponent: () => import('./components/pages/templates/templates-create/templates-create').then(m => m.TemplatesCreate),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'templates/edit/:id',
        loadComponent: () => import('./components/pages/templates/templates-edit/templates-edit').then(m => m.TemplatesEdit),
        canActivate: [roleGuard],
        data: { roles: [Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'valutazioni',
        loadComponent: () => import('./components/pages/valutazioni/valutazioni').then(m => m.Valutazioni),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'qualifica',
        loadComponent: () => import('./components/pages/qualifica/qualifica').then(m => m.Qualifica),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'qualifica/view/:id',
        loadComponent: () => import('./components/pages/qualifica/qualifica-view/qualifica-view').then(m => m.QualificaView),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'tariffe',
        loadComponent: () => import('./components/pages/tariffe/tariffe').then(m => m.Tariffe),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE, Role.FORNITORE, Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },



      {
        path: 'tipologie-fornitori',
        loadComponent: () => import('./components/pages/gestione-portale/tipologie-fornitori/tipologie-fornitori').then(m => m.TipologieFornitori),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'tipologie-assets',
        loadComponent: () => import('./components/pages/gestione-portale/tipologie-assets/tipologie-assets').then(m => m.TipologieAssets),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'tipologie-documenti',
        loadComponent: () => import('./components/pages/gestione-portale/tipologie-documenti/tipologie-documenti').then(m => m.TipologieDocumenti),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'tipologie-articoli',
        loadComponent: () => import('./components/pages/gestione-portale/tipologie-articoli/tipologie-articoli').then(m => m.TipologieArticoli),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'societa',
        loadComponent: () => import('./components/pages/gestione-portale/societa/societa').then(m => m.Societa),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'notifiche',
        loadComponent: () => import('./components/pages/gestione-portale/notifiche/notifiche').then(m => m.Notifiche),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'clienti',
        loadComponent: () => import('./components/pages/gestione-portale/clienti/clienti').then(m => m.Clienti),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'tipologie-documenti-dipendenti',
        loadComponent: () => import('./components/pages/gestione-portale/tp-doc-dipendenti/tp-doc-dipendenti').then(m => m.TpDocDipendenti),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      },
      {
        path: 'previewpdf/:type/:id',
        loadComponent: () => import('./components/pages/preview-pdf/preview-pdf').then(m => m.PreviewPdf),
        canActivate: [roleGuard],
        data: { roles: [Role.OPERATORE,Role.AMMINISTRATORE, Role.SUPERAMMINISTRATORE] }
      }
    ]
  },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];